import { Injectable, inject } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { map, switchMap, filter, catchError, withLatestFrom } from 'rxjs/operators';
import * as actions from '../actions';
import * as featureActions from '../../my-features/index';
import {DevicesService} from '../../services/devices.service';
import {User} from '../../models/user';
import * as fromStore from '../../store';
import { Store, select } from '@ngrx/store';
import {UsersState} from '../reducers/user.reducers';
import {EventsParams} from '../../models/events';
import {UpdateInfoModel} from '../../my-features/updateInfo/update-info.model';
import {updateInfoType} from '../../shareModel';
import {Update} from '@ngrx/entity';
import {FloorMap} from '../../my-features/floor-map/floor-map.model';
import {Device} from '../../my-features/device/device.model';

@Injectable()
export class DevicesInfoEffects {
  private actions$ = inject(Actions);
  private deveicesService = inject(DevicesService);
  private store$ = inject(Store<fromStore.State>);

  constructor() {}

  getDevicesInfoEffect$ = createEffect(() => this.actions$.pipe(
    ofType(actions.DevicesInfoTypes.GET_DEVICE_INFO),
    map((action: actions.GetDeviceInfoAction) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, currentUser]) => {
      const param = (payload !== null && payload.regionIds !== null && payload.regionIds !== undefined) ?
                    {otp: currentUser.otp, RegionIds: payload.regionIds} : currentUser.otp;
      return this.deveicesService.getDevicesInfo(param).pipe(
        map((res: any) => {
          if (res && Array.isArray(res)) {
            return new actions.GetDeviceInfoSuccessAction(res);
          } else {
            return new actions.GetDeviceInfoSuccessAction([]);
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => of(new actions.GetDeviceInfoFailAction(error)))
      );
    })
  ));
  updateDeviceInfoEffect$ = createEffect(() => this.actions$.pipe(
    ofType(actions.DevicesInfoTypes.UPDATE_DEVICE_INFO),
    map((action: actions.UpdateDeviceInfoAction) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, currentUser]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const params = {
        ...payload,
        otp: currentUser.otp,
        BRD_From: 1 // From Web
      };
      return this.deveicesService.updateDeviceInfo(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          // const RangeParam: EventsParams = {
          //   otp: '',
          //   startDate: new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 30),
          //   endDate: new Date()
          // };
          const result = { ...res, type: updateInfoType.EditDeviceInfo };
          if (result.result) {
            // refresh temp devices info
            const update: Update<Device> = {
              id: payload.dcode,
              changes: {
                DeviceName: payload.deviceName
              }
            };
            return [new featureActions.UpdateInfoSuccessAction(result), new featureActions.UpdateDevice({device: update})];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
          // new actions.GetDeviceInfoAction();
          // new actions.GetEventAction(RangeParam);
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError((error) => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditDeviceInfo
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
}
